<script>
	import { onMount } from 'svelte';
	import { push, querystring } from 'svelte-spa-router';
	import fetchData from '../../api.js';
	import UserStore from '../../stores/user';
	import { cartsStore } from '../../stores/cartStore';
	import { activeCartId, setActiveCart } from '../../stores/activeCart';
	import { money, formatDate } from '../../lib/format';
	import AppShell from '../../components/AppShell.svelte';
	import CustomerPicker from '../../components/CustomerPicker.svelte';
	import Icon from '../../components/Icon.svelte';

	let loading = true;
	let picking = false;
	let creating = false;

	$: carts = Object.values($cartsStore || {}).sort((a, b) => Number(b.id) - Number(a.id));

	async function load() {
		const res = await fetchData({ action: 'agents_get_carts', token: $UserStore.data });
		cartsStore.set((res && res.data) || {});
		loading = false;
	}

	async function create(customer) {
		picking = false;
		creating = true;
		const res = await fetchData({ action: 'agents_create_cart', token: $UserStore.data, customer: customer || null });
		creating = false;
		if (res && res.data && res.data.id) {
			await setActiveCart(res.data.id);
			push('/agents/products');
		}
	}

	function open(cart) {
		setActiveCart(cart.id);
		push('/agents/carts/' + cart.id);
	}

	onMount(() => {
		if (!$UserStore || !$UserStore.data) {
			push('/login');
			return;
		}
		load();
		// "סל חדש" from the cart screen lands here with ?new=1
		if ($querystring && $querystring.includes('new=1')) picking = true;
	});
</script>

<AppShell title="סלים פתוחים">
	<div class="top">
		<p class="muted">סלים שעוד לא נשלחו. לוחצים על סל כדי להמשיך לעבוד עליו.</p>
		<button class="btn-primary" on:click={() => (picking = true)} disabled={creating}><Icon name="plus" size={20} /> סל חדש</button>
	</div>

	{#if loading}
		<div class="spinner" />
	{:else if !carts.length}
		<div class="empty-state"><b>אין סלים פתוחים</b>פותחים סל חדש, בוחרים לקוח ומוסיפים מוצרים.</div>
	{:else}
		<div class="list">
			{#each carts as c (c.id)}
				<button class="item" class:active={String(c.id) === String($activeCartId)} on:click={() => open(c)}>
					<span class="avatar">{(c.customer_name || '?').trim().charAt(0)}</span>
					<span class="who">
						<b>{c.customer_name || 'ללא לקוח'}</b>
						<span class="muted">סל {c.id} · {formatDate(c.date_time)}{#if $UserStore.role === 'admin'} · {c.agent_name || 'ללא סוכן'}{/if}</span>
					</span>
					{#if String(c.id) === String($activeCartId)}<span class="badge-dark">פעיל</span>{/if}
					<span class="nums">
						<b>{money(c.total)}</b>
						<span class="muted">{Number(c.units) || 0} יח׳</span>
					</span>
				</button>
			{/each}
		</div>
	{/if}
</AppShell>

{#if picking}
	<CustomerPicker skipLabel="פתיחת סל בלי לקוח בינתיים" on:close={() => (picking = false)} on:select={(e) => create(e.detail)} on:skip={() => create(null)} />
{/if}

<style>
	.top { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 16px; }
	.top p { margin: 0; }
	.list { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
	.item {
		display: flex; align-items: center; gap: 14px; min-height: 84px; padding: 14px 18px; text-align: start;
		background: var(--surface); border: 1px solid var(--line); border-radius: var(--radius);
	}
	.item.active { border-color: var(--ink); box-shadow: inset 0 0 0 1px var(--ink); }
	.avatar { width: 48px; height: 48px; border-radius: 50%; background: var(--bg); display: grid; place-items: center; font-weight: 800; font-size: 19px; flex: none; }
	.who { flex: 1; min-width: 0; display: flex; flex-direction: column; }
	.who b { font-size: 18px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.who span { font-size: 14px; }
	.nums { display: flex; flex-direction: column; align-items: flex-end; }
	.nums b { font-size: 19px; }
	.nums span { font-size: 14px; }
	@media (max-width: 1000px) {
		.list { grid-template-columns: 1fr; }
	}
</style>
